import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function BlogCTA() {
    return (
        <section className="bg-[#F8F9FA] py-20">
            <div className="max-w-2xl mx-auto px-6 text-center">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-3xl text-navy-900 mb-4">Ready to stop reading and start building?</h2>
                    <p className="text-[#6B7280] mb-8 text-sm">See the program. Get the structure. Build the leverage.</p>
                    <Link to="/contact" className="inline-block bg-navy-900 text-white px-8 py-3.5 rounded-sm text-sm font-bold hover:bg-navy-950 transition-colors" data-testid="blog-cta">
                        Get Started
                    </Link>
                </motion.div>
            </div>
        </section>
    );
}
